import React, { useEffect, useState } from "react";
import { AddButtonContainer, StyledContainer } from "./Style";
import type { ColumnsType, TableProps } from 'antd/es/table';
import { Table, Button, Space, Row } from 'antd';
import Spinner from "../Spinner";
import { FileExcelFilled, PrinterFilled } from '@ant-design/icons';
import { errorNotify, sucessNotify } from "../../../services/toast.notification";
import { ExportToCsv } from 'export-to-csv';

export interface InputProps {
  title?: string;
  columns: ColumnsType<any>
  data: any,
  isloading: Boolean;
  onChange?: any,
  onSort?: any,
  onFilter?: any,
  onAddClick?: any,
  addButtonTitle?: any,
  expandedRowRender?: any[],
  permission:any
}


const options = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: true,
  showTitle: false,
  title: 'گزارش از سیستم پارسی پل',
  useTextFile: false,
  useBom: true,
  useKeysAsHeaders: true,
  // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
};

const MachineInstallTable = ({ title, columns, data, isloading, onChange, onSort, onFilter,
  onAddClick, addButtonTitle = 'جدید', expandedRowRender,permission }: InputProps) => {
  const [height, setHeight] = useState(300);
  useEffect(() => {

    if (window.innerHeight - 200 > 300) {
      setHeight(window.innerHeight - 200)
    }
  }, [])
  const exportToExcell = () => {

    if (!data) {
      errorNotify("داده ای جهت خروجی وجود ندارد");
      return;
    }

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(prepareDatasetForExport());
    sucessNotify("فایل خروجی با موفقیت ساخته شد");

  }

  const print = () => {
    errorNotify("این گزینه در حال حاضر غیر فعال می باشد")
  }


  const prepareDatasetForExport = () => {

    let res: Array<any> = new Array<any>;

    data.forEach((item: any, index: number) => {

      let row = { ["ردیف"]: index + 1 };

      console.log(item);
      columns.forEach((col: any) => {
        if (col.title != "" && col.title != "-" && col.dataIndex != "Action") 
        row = { ...row, [col.title]: item[col.dataIndex].toString().replaceAll("/", "") }
        console.log([col.title]);
       // console.log(item[col.dataIndex]);
      });

      //console.log(row);
      res.push(row);

    });

    //console.log(res);
    return res;

  }
  const showDecData = (r: any, i: any) => {
    if ((expandedRowRender != undefined) && expandedRowRender.length > 0) {

      return expandedRowRender.map((item) =>
        
      <p style={{ margin: 0, textAlign: 'right', fontSize: '13px',borderBottom:'1px solid #c3c0c0',padding:'3px 0px' }}>
      
        <span style={{display:'inline-block',padding:'0px 10px' , color:'#252525',fontWeight:'bold'}}>
          {[item.title]}
          :
        </span>
        <span style={{color:'##353535'}}>
          {r[item.val]}
        </span>

      </p>
      );

    }
    else
      return ''
  }
  const [activeExpRow, setActiveExpRow] = React.useState();

  const onExpand= (expanded:any, record:any) => {
    const keys :any= [];
    debugger
    if (expanded) {
      // keys.push(record.index);
      keys.push(record.id);
    }
    console.log(keys);
    setActiveExpRow(keys);
  }
  const rowExpandabl=(r:any)=>{
    return true
  }
  return (
    <StyledContainer>

      {isloading === false && onAddClick !== undefined && (
        <AddButtonContainer>
          <Button type="primary" disabled={!permission} style={{ backgroundColor: "Green" }} onClick={onAddClick}>{addButtonTitle}</Button>
        </AddButtonContainer>
      )}

      {isloading === false && (
        <>
          <FileExcelFilled disabled={!permission} style={{ color: 'Green', fontSize: '18px', marginRight: '6px' }} onClick={exportToExcell} />
          {/* <PrinterFilled disabled={!permission} style={{ color: 'Blue', fontSize: '18px', marginRight: '6px' }} onClick={print} /> */}
          {window.matchMedia('(max-width: 1023px)').matches && (
            <Table scroll={{ x: 1500 }} dataSource={data} columns={columns}
              expandable={{
                expandedRowRender: (record: any, i) =>
                  showDecData(record, i)
              }}
              onExpand={onExpand}
              expandedRowKeys= {activeExpRow}
              
            />
          )}
          {!window.matchMedia('(max-width: 1023px)').matches && data && data.length>0 && (
            <Table scroll={{ x: 1500 }}
              dataSource={data} columns={columns}
              rowClassName={(record) => (record.bit_deleted ? "deleted-row" :"not-deleted-row" )}

            />
          )}
          {data && data.length == 0 && (
             <Row style={{ display: 'flex', justifyContent: 'center', paddingTop: '20px', paddingBottom: '400px' }}>

             <center><p style={{ color: 'red' }}>با مقادیر انتخاب شده داده ای برای نمایش وجود ندارد.</p></center>

         </Row>
          )}
        </>
      )}

      {isloading === true && (
        <Spinner />
      )}

    </StyledContainer>
  )

};

export default MachineInstallTable;
